const genDefectCodes = (codes) => {
  const keys = Object.keys(codes).sort();
  const defectCodes = [];
  for (const k of keys) {
    const tp = codes[k];
    for (let i = 0; i < tp.codes.length; i++) {
      defectCodes.push({
        defect_code: k + String(i+1),
        defect_type: k,
        defect_index: i + 1,
        defect_code_desc_ENG: tp.codes[i],
        defect_type_desc_ENG: k + ": " + tp['type_desc'],
      });
    }
  }
  return defectCodes;
};

module.exports = {
  genDefectCodes
};
